import { onMounted, ref } from 'vue'

type Position = 'left' | 'right' | 'both' | 'none'

const MIN_SCROLL_LEFT = 20

export function useHorizontalScroll(scrollPercentage = 0.3) {
  const carouselRef = ref<HTMLElement | null>(null)

  const scrollSize = computed(() => {
    if (!carouselRef.value)
      return MIN_SCROLL_LEFT
    return Math.round(carouselRef.value.clientWidth * scrollPercentage)
  })

  const fadePosition = ref<Position>('none')

  const handleScroll = () => {
    if (!carouselRef.value)
      return

    const { scrollLeft, scrollWidth, clientWidth } = carouselRef.value
    const maxScrollLeft = scrollWidth - clientWidth
    if (maxScrollLeft < MIN_SCROLL_LEFT) {
      fadePosition.value = 'none'
      return
    }

    if (scrollLeft > 0 && scrollLeft < maxScrollLeft) {
      fadePosition.value = 'both'
      return
    }

    if (scrollLeft > 0) {
      fadePosition.value = 'left'
      return
    }

    if (scrollLeft < maxScrollLeft) {
      fadePosition.value = 'right'
      return
    }

    fadePosition.value = 'none'
  }

  const scrollDirection = (direction: 'left' | 'right') => {
    if (!carouselRef.value)
      return
    carouselRef.value.scrollTo({
      left:
        carouselRef.value.scrollLeft
        + (direction === 'left' ? -scrollSize.value : scrollSize.value),
      behavior: 'smooth',
    })
  }

  onMounted(() => {
    if (carouselRef.value)
      handleScroll()
  })

  return {
    carouselRef,
    fadePosition,
    handleScroll,
    scrollDirection,
  }
}
